import controller from './custom-typeahead-controller';
import template from './custom-typeahead.html';

const CustomTypeaheadComponent = {
    bindings: {
        clearAfterSelect: '<',
        emptyDisplayName: '<',
        isDisabled: '<',
        itemDisplayProp: '<',
        itemList: '<',
        onItemSelect: '&',
        selectedDisplay: '<'
    },
    controller,
    template
};

export default CustomTypeaheadComponent;



// WEBPACK FOOTER //
// ./app/common/custom-typeahead/custom-typeahead-component.js